import { render, staticRenderFns } from "./IcdCollection.vue?vue&type=template&id=408d941c&scoped=true&"
import script from "./IcdCollection.vue?vue&type=script&lang=js&"
export * from "./IcdCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d941c",
  null
  
)

export default component.exports